"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClientApi = void 0;
var tslib_1 = require("tslib");
var http_client_1 = require("@wix/http-client");
var httpClient = new http_client_1.HttpClient();
exports.HttpClientApi = {
    doRequest: function (ambassadorRequest, params, headers) {
        return httpClient.request(function (ctx) {
            return tslib_1.__assign(tslib_1.__assign({}, ambassadorRequest(params)(ctx)), { headers: headers });
        });
    },
    doPost: function (url, params, headers) {
        return httpClient.post(url, params, {
            headers: headers,
        });
    },
    doGet: function (url, params, headers) {
        return httpClient.get(url, {
            params: params,
            headers: headers,
        });
    },
};
//# sourceMappingURL=HttpClient.js.map